export enum ITEMS_TYPES {
  TEXT = 'TEXT',
  PASSWORD = 'PASSWORD',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  TEXTAREA = 'TEXTAREA',
  NUMBER = 'NUMBER',
  DROPDOWN = 'DROPDOWN',
  MULTISELECT = 'MULTISELECT',
  CHIPS = 'CHIPS',
  TOGGLE = 'TOGGLE',
  SELECT = 'SELECT',
  DATEPICKER = 'DATEPICKER',
  DERIVED = 'DERIVED',
  TEXT_MULTILINES = 'TEXT_MULTILINES',
  MULTISELECT_WITH_MANUAL = 'MULTISELECT_WITH_MANUAL',
  RADIO = 'RADIO',
  UPLOAD = 'UPLOAD',
  CHECKBOX = 'CHECKBOX',
  CONTAINER = 'CONTAINER',
  TOGGLE_SWITCH = 'TOGGLE_SWITCH',
  WIDGET = 'WIDGET',
  HIDDEN = 'HIDDEN',
  PLACEHOLDER = 'PLACEHOLDER',
  TOGGLE_BUTTON = 'TOGGLE_BUTTON'
}

export enum LABEL_TEMPLATE_TYPES {
  DEFAULT,
  MULTILINKS
}

export const ELEMENT_INDEX_MIN = 0;
export const ELEMENT_INDEX_MAX = 100000;

